import { render, staticRenderFns } from "./CreatePayment.vue?vue&type=template&id=0cd8a35b"
import script from "./CreatePayment.vue?vue&type=script&lang=js"
export * from "./CreatePayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cd8a35b')) {
      api.createRecord('0cd8a35b', component.options)
    } else {
      api.reload('0cd8a35b', component.options)
    }
    module.hot.accept("./CreatePayment.vue?vue&type=template&id=0cd8a35b", function () {
      api.rerender('0cd8a35b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/payments/CreatePayment.vue"
export default component.exports